export const SET_USER = "SET_USER";
export const SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED";
export const SET_MODULE_ACCESS = "SET_MODULE_ACCESS";
export const SET_IS_CURRENT_MODULE_ADMIN = "SET_IS_CURRENT_MODULE_ADMIN";
